import dayjs from 'dayjs'
import { formatters } from '@utils/intl/dateTimeFormatters'
import type { ScheduleGridProps } from '../types'
import { groupBy } from 'lodash'

export function generateDriverScheduleData(
  scheduleData: ScheduleGridProps['scheduleData'],
  shiftIndex: number,
  selectedDepots: string[],
  selectedDrivers: string[]
) {
  return Object.entries(
    groupBy(
      (scheduleData?.[shiftIndex]?.rows ?? []).filter(
        (d) =>
          (!selectedDepots.length || selectedDepots.includes(d.home_location)) &&
          (!selectedDrivers.length || selectedDrivers.includes(d.driver_name))
      ),
      (d) => d.home_location
    )
  )
}

// 2025-03-26 00:00:00-am to 03/26 AM/PM (selected)
export function formatGridMenuItems(
  schedules: ScheduleGridProps['scheduleData'],
  selectedIds: { [shiftIndex: string]: string[] }
) {
  return schedules?.map((schedule, key) => ({
    key,
    label: `${formatters.MONTH_DAY(dayjs(schedule.shift.split(' ')?.[0]))} ${schedule.shift
      .split('-')?.[3]
      .toUpperCase()} (${selectedIds?.[key]?.length ?? 0})`,
  }))
}

export function formatDriverList(schedule: ScheduleGridProps['scheduleData'], shiftIndex: number) {
  return Array.from(new Set(schedule?.[shiftIndex]?.rows.map((row) => row.driver_name)))
    .sort()
    .map((d) => ({
      label: d,
      value: d,
    }))
}

export function findShiftIndexById(id: string, data: ScheduleGridProps['scheduleData']) {
  return data?.findIndex((schedule) => {
    return schedule?.rows?.some((row) => row.id === id)
  })
}
